/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ remoteModule)
});

;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "core-js/modules/es.date.to-json.js"
const es_date_to_json_js_namespaceObject = require("core-js/modules/es.date.to-json.js");
;// external "core-js/modules/es.function.name.js"
const es_function_name_js_namespaceObject = require("core-js/modules/es.function.name.js");
;// external "core-js/modules/es.json.stringify.js"
const es_json_stringify_js_namespaceObject = require("core-js/modules/es.json.stringify.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// external "frontend-remote-modules"
const external_frontend_remote_modules_namespaceObject = require("frontend-remote-modules");
;// external "core-js/modules/es.array.map.js"
const es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// ./utils/src/marginHelpers.js

var SPACING_MARGIN_MODE = {
  ALL: 'all',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var setVerticalMargins = function setVerticalMargins(margins) {
  var marginTop = margins === null || margins === void 0 ? void 0 : margins.top;
  var marginBottom = margins === null || margins === void 0 ? void 0 : margins.bottom;
  return {
    marginTop: marginTop,
    marginBottom: marginBottom
  };
};
var setHorizontalMargins = function setHorizontalMargins(margins) {
  var marginLeft = margins === null || margins === void 0 ? void 0 : margins.left;
  var marginRight = margins === null || margins === void 0 ? void 0 : margins.right;
  return {
    marginLeft: marginLeft,
    marginRight: marginRight
  };
};
var setMargins = function setMargins(margins, isMobile) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SPACING_MARGIN_MODE.VERTICAL;
  var _ref = margins || {},
    desktop = _ref.desktop,
    mobile = _ref.mobile;
  var deviceMargins = isMobile ? mobile : desktop;
  var horizontalMargins = mode === SPACING_MARGIN_MODE.VERTICAL ? {} : setHorizontalMargins(deviceMargins);
  var verticalMargins = mode === SPACING_MARGIN_MODE.HORIZONTAL ? {} : setVerticalMargins(deviceMargins);
  return objectSpread2_default()(objectSpread2_default()({}, verticalMargins), horizontalMargins);
};
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/molecules/spacer/src/Spacer.js




/**
 * Component dependencies
 */





var namespace = 'pog-ui-spacer';

/**
 * Component
 */

var Spacer = function Spacer(_ref) {
  var children = _ref.children,
    margins = _ref.margins,
    isMobile = _ref.isMobile;
  // Returns null if given child is not a valid React component
  if (! /*#__PURE__*/(0,external_react_namespaceObject.isValidElement)(children)) {
    return null;
  }
  var options = margins ? setMargins(margins, isMobile, SPACING_MARGIN_MODE.VERTICAL) : null;
  var styles = objectSpread2_default()({}, options);
  if (!margins || !styles.marginTop && !styles.marginBottom) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
      children: children
    });
  }
  return margins && /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(namespace),
    style: styles
  }, void 0, external_react_namespaceObject.Children === null || external_react_namespaceObject.Children === void 0 ? void 0 : external_react_namespaceObject.Children.map(children, function (child) {
    return /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(child, objectSpread2_default()({}, child.props));
  }));
};
Spacer.defaultProps = {
  margins: null,
  isMobile: false
};
/* harmony default export */ const src_Spacer = (Spacer);
;// ./components/molecules/remoteModuleError/src/RemoteModuleError.js



var RemoteModuleError_namespace = 'pog-ui-frm-error';
var RemoteModuleErrorComponent = function RemoteModuleErrorComponent(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/jsx_default()("p", {
    className: RemoteModuleError_namespace
  }, void 0, "Remote module error: ", error !== null && error !== void 0 && error.message ? error.message : 'unexpected error');
};
RemoteModuleErrorComponent.defaultProps = {};
/* harmony default export */ const RemoteModuleError = (RemoteModuleErrorComponent);
;// external "@andes/progress-indicator-circular"
const progress_indicator_circular_namespaceObject = require("@andes/progress-indicator-circular");
var progress_indicator_circular_default = /*#__PURE__*/__webpack_require__.n(progress_indicator_circular_namespaceObject);
;// ./components/molecules/loader/src/Loader.js


/**
 * Module dependencies
 */





var Loader_namespace = 'pog-ui-loader';

/**
 * Section
 */
var Loader = function Loader(props) {
  var className = props.className;
  return /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(Loader_namespace, className)
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((progress_indicator_circular_default()), objectSpread2_default()({
    srLabel: "Cargando"
  }, props)));
};

/**
 * PropTypes
 */

/**
 * Default Props
 */
Loader.defaultProps = {
  className: '',
  modifier: 'block',
  size: 'large'
};

/**
 * Export shortcut-card
 */
/* harmony default export */ const src_Loader = (Loader);
;// external "core-js/modules/es.number.constructor.js"
const es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// external "core-js/modules/es.number.is-nan.js"
const es_number_is_nan_js_namespaceObject = require("core-js/modules/es.number.is-nan.js");
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// ./components/hooks/useOnScreen.js


var useOnScreen = function useOnScreen(ref) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = (0,external_react_namespaceObject.useMemo)(function () {
    if (typeof IntersectionObserver !== 'function') {
      setIsVisible(false);
      return null;
    }
    return new IntersectionObserver(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 1),
        entry = _ref2[0];
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: threshold
    });
  }, [ref]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (observer) {
      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    isVisible: isVisible,
    observer: observer
  };
};
;// ./components/hooks/useTrackShow.js





var useTrackShow = function useTrackShow(refModule, tracking, sectionMetadata) {
  var requireDispatchCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = tracking || {},
    onShow = _ref.onShow;
  var refElement = onShow !== null && onShow !== void 0 && onShow.enabled ? refModule : null;
  var customThreshold = Number(onShow === null || onShow === void 0 ? void 0 : onShow.threshold);
  var threshold = 0.9;
  if (!Number.isNaN(customThreshold) && customThreshold >= 0.0 && customThreshold <= 1.0) {
    threshold = customThreshold;
  }
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackShow = (0,framework_namespaceObject.getShowTrackingFn)(trackingHandler);
  var _useOnScreen = useOnScreen(refElement, threshold),
    isVisible = _useOnScreen.isVisible,
    observer = _useOnScreen.observer;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isVisible) {
      trackShow(sectionMetadata);
      if (observer) {
        observer.disconnect();
      }
    }
  }, [isVisible]);
  if (requireDispatchCall) {
    var sendTrackShow = function sendTrackShow(data) {
      trackShow(data);
    };
    return {
      isVisible: isVisible,
      sendTrackShow: sendTrackShow
    };
  }
  return {
    isVisible: isVisible
  };
};
/* harmony default export */ const hooks_useTrackShow = (useTrackShow);
;// ./components/sections/remoteModule/src/RemoteModule.js


var _Loader, _Loader2, _div, _div2, _div3, _div4;












var RemoteModule_namespace = 'pog-ui-frm';
var loaderClassname = "".concat(RemoteModule_namespace, "__frm-loading");
var LoadingComponent = function LoadingComponent() {
  return _Loader || (_Loader = _Loader2 || (_Loader2 = /*#__PURE__*/jsx_default()(src_Loader, {
    className: loaderClassname,
    show: true
  })));
};
var LoadingEmptyComponent = function LoadingEmptyComponent() {
  return _div || (_div = _div2 || (_div2 = /*#__PURE__*/jsx_default()("div", {
    className: loaderClassname
  })));
};
var EmptyComponent = function EmptyComponent() {
  return _div3 || (_div3 = _div4 || (_div4 = /*#__PURE__*/jsx_default()("div", {})));
};
var RemoteModule = function RemoteModule(_ref) {
  var id = _ref.id,
    className = _ref.className,
    moduleId = _ref.moduleId,
    host = _ref.host,
    path = _ref.path,
    root = _ref.root,
    name = _ref.name,
    isolated = _ref.isolated,
    showLoader = _ref.showLoader,
    showLoadingError = _ref.showLoadingError,
    debug = _ref.debug,
    data = _ref.data,
    margins = _ref.margins,
    isMobile = _ref.isMobile,
    tracking = _ref.tracking,
    sectionMetadata = _ref.sectionMetadata;
  var moduleRef = (0,external_react_namespaceObject.useRef)(null);
  hooks_useTrackShow(moduleRef, tracking, sectionMetadata);
  return /*#__PURE__*/jsx_default()(src_Spacer, {
    isMobile: isMobile,
    margins: margins
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(RemoteModule_namespace, className),
    id: id || "frm-container-".concat(moduleId)
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    ref: moduleRef,
    className: external_classnames_default()("".concat(RemoteModule_namespace, "__frm-container"), "".concat(className, "__frm-container")),
    id: moduleId,
    children: [debug && /*#__PURE__*/jsx_default()("p", {}, void 0, "Content for module ", name, " @ ", host, path, " goes here. Modules looked up on: ", root), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(external_frontend_remote_modules_namespaceObject.Module, objectSpread2_default()(objectSpread2_default()({
      id: moduleId,
      host: host,
      path: path,
      root: root,
      name: name,
      isolated: isolated
    }, data), {}, {
      loadingComponent: debug || showLoader ? LoadingComponent : LoadingEmptyComponent,
      errorComponent: debug || showLoadingError ? RemoteModuleError : EmptyComponent
    }))]
  }), debug && /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()("".concat(RemoteModule_namespace, "__frm-data"))
  }, void 0, "Data received:", /*#__PURE__*/jsx_default()("pre", {}, void 0, JSON.stringify(data, null, 2)))));
};

/**
 * PropTypes
 */

RemoteModule.defaultProps = {
  id: '',
  className: '',
  path: '/',
  root: '/modules',
  debug: false,
  isolated: true,
  showLoader: true,
  showLoadingError: false,
  margins: null,
  isMobile: false
};

/**
 * Export RemoteModule
 */
/* harmony default export */ const src_RemoteModule = (RemoteModule);
;// ./packages/remoteModule/src/RemoteModule.js

/* harmony default export */ const remoteModule_src_RemoteModule = (src_RemoteModule);
;// ./packages/remoteModule/index.js
/**
 * Export Component
 */

/* harmony default export */ const remoteModule = (remoteModule_src_RemoteModule);
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map